export class Debouncer {

    public static createDefault(): Debouncer {
        return new Debouncer(250);
    }
    private timerId: any;
    private delay: number;

    constructor(delay: number) {
        this.delay = delay;
    }

    public update(callback: any) {
        clearTimeout(this.timerId);
        this.timerId = setTimeout(() => {
            callback();
        }, this.delay);
    }
}
